const state = {
    STATE: 0,
    MODELS: [],
    ERRORS: [],
    OFFERS_FULL: [],
    OFFERS_FULL_COUNT: 0,
    CMS_DISCLAIMER: '',
    FINANCE_FILTER_TERM: 48,
    FINANCE_FILTER_ADVANCE: 3,
    FINANCE_FILTER_MILEAGE: 10000,
    FINANCE_FILTER_MAINT: false,
    VEHICLE: null,
    SME_DESCRIPTIONS: [],
    SEARCH_RESULTS: null,
    SEARCH_RESULTS_COUNT: 0,
    SEARCH_RESULTS_PER_PAGE: 20,
    SEARCH_RESULTS_PAGE: 1,
    FILTER_DATA_BODY: [],
    FILTER_DATA_MANUFACTURER: [],
    FILTER_DATA_MODEL: [],
    FILTER_DATA_FUEL_TYPES: [],
    FILTER_MANUFACTURER: null,
    FILTER_FUEL_TYPE: null,
    FILTER_CO2: [],
    FILTER_RENTAL: [],
    FILTER_BODY: [],
    FILTER_TRIM: null,
    FILTER_TYPE: 'CAR',
    FILTER_MODEL: [],
    FILTER_ORDER: 'finance-asc',
    SEARCH_BUSY: false,
    CAR_RENTAL_VALUES: [150, 300, 450, 600, 750, 1000, 2000, 4000],
    CAR_CO2_VALUES: [0, 50, 100, 150, 200, 250, 350],
    LCV_RENTAL_VALUES: [100, 250, 500, 750, 1000],
    LCV_CO2_VALUES: [100, 150, 200, 250],
    SERVICE_COST: 3.44,
    PRESET_MANUFACTURER: false,
    MANUFACTURER_LIST: null
};

export default state;